<template>
    <login-dialog></login-dialog>
</template>

<script>
  import LoginDialog from '../components/login/LoginDialog'
  export default {
    name: 'LoginPage.vue',
    components: { LoginDialog }
  }
</script>

<style scoped>

</style>
